import uiRouter from 'angular-ui-router';
import loansRoutingComponent from './loansRouting.component';
import loansRoutingService from './loansRouting.service';
import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';

let loansRoutingModule = angular.module('loans.routing', [
  uiRouter,
])

  .config(($stateProvider) => {
    'ngInject';

    $stateProvider
      .state(STATES.LOANS.ROOT, {
        abstract: true,
        parent: STATES.MAIN_ROUTING,
        url: ROUTES.LOANS.ROOT,
        component: 'loansRouting',
        params:{
          goWageAdvance: null,
        },
        data: {
          requiresAuth: true,
        },
        resolve: {
          /* @ngInject */
          moduleClosed: (StatusAppCheckers) => StatusAppCheckers.getClosedModules()
        }
      });
  })

  .component('loansRouting', loansRoutingComponent)

  .service('loansRoutingService', loansRoutingService)

  .name;

export default loansRoutingModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansRouting/loansRouting.js